import {
  Number,
  Record,
  Static,
  String,
} from 'runtypes';

export const SurveyResponseRequestRuntype = Record({
  response: String.Or(Number),
  surveyQuestionId: Number,
});

export interface ISurveyResponseRequest extends Static<typeof SurveyResponseRequestRuntype> {
};



// WEBPACK FOOTER //
// ./src/services/ISurveyResponseRequest.ts